import { Box } from '@mui/material';
import { GridToolbarColumnsButton, GridToolbarProps } from '@mui/x-data-grid-pro';
import type { ReactNode } from 'react';

// Lets a grid pass content to this toolbar through `slotProps.toolbar`.
declare module '@mui/x-data-grid-pro' {
  interface ToolbarPropsOverrides {
    /** Shown at the toolbar's start, e.g. a title. With it, the columns button moves
     * to the far end of the row. */
    startContent?: ReactNode;
  }
}

type ColumnsOnlyToolbarProps = GridToolbarProps & {
  startContent?: ReactNode;
};

// Custom toolbar with only the columns button. Given start content (a title), that
// sits at the left and the columns button at the right; without it, the columns button
// is at the left, as before.
export const ColumnsOnlyToolbar = ({ startContent, ...props }: ColumnsOnlyToolbarProps) => (
  <Box
    sx={{ paddingTop: 2, px: 3, display: 'flex', alignItems: 'center', gap: 3, minWidth: 0 }}
    {...props}
  >
    {startContent}
    <Box sx={{ flexShrink: 0, ...(startContent ? { ml: 'auto' } : {}) }}>
      <GridToolbarColumnsButton
        slotProps={{
          button: {
            sx: {
              textTransform: 'none',
              padding: '4px 5px',
            },
          },
        }}
      />
    </Box>
  </Box>
);
